<ng-container *ngIf="!!get">
    <tt-tabs ttRememberId="w_projectmenu.gb_projectmenu_main" [(ttSelectedId)]="get.gb_projectmenu_main" (ttSelectedIdChange)="onTabChange()">
        <tt-tab ttId="EDIT" ttLabel="gb_projectmenu_main_edit" ttIcon="far fa-edit"></tt-tab>
        <tt-tab *ngIf="dashboard.kpiCompKeynos.length > 0" ttId="DASHBOARD" ttLabel="bg_main_dashboard" ttIcon="far fa-analytics"></tt-tab>
        <tt-tab ttId="CUSTACTS" ttLabel="gb_projectmenu_main_custacts" ttIcon="far fa-tasks"></tt-tab>
        <tt-tab ttId="EMAILS" ttLabel="gb_projectmenu_main_emails" ttIcon="far fa-envelope"></tt-tab>
        <tt-tab ttId="DOCUMENTS" ttLabel="gb_projectmenu_main_documents" ttIcon="far fa-file-alt"></tt-tab>
        <tt-tab ttId="ORDERHEADS" ttLabel="gb_projectmenu_main_orderheads" ttIcon="far fa-file-contract"></tt-tab>
        <tt-tab ttId="PURCHHEADS" ttLabel="gb_projectmenu_main_purchheads" ttIcon="far fa-shopping-cart"></tt-tab>
        <tt-tab *ngIf="get.show_tab_custactac === '1'" ttId="INCOMING_INVOICE" ttLabel="gb_projectmenu_main_incoming_invoice" ttIcon="far fa-dollar-sign"></tt-tab>
        <tt-tab ttId="POWTIMES" ttLabel="gb_projectmenu_main_powtimes" ttIcon="far fa-clock"></tt-tab>
        <tt-tab ttId="DOCPACKS" ttLabel="gb_projectmenu_main_docpacks" ttIcon="far fa-box"></tt-tab>
        <tt-tab ttId="FOLDERS" ttLabel="gb_projectmenu_main_folders" ttIcon="far fa-folders"></tt-tab>
        <tt-tab ttId="FUNCTIONS" ttLabel="gb_projectmenu_main_functions" ttIcon="far fa-ellipsis-h"></tt-tab>
    </tt-tabs>

    <tt-project [hidden]="get.gb_projectmenu_main !== 'EDIT'" [params]="params" (submit)="onProjectSubmit($event)" style="max-width: 180rem"></tt-project>
    <tt-webpagemenu-dashboard
        [hidden]="get.gb_projectmenu_main !== 'DASHBOARD'"
        #dashboard
        class="col-xs-12 sp-0"
        ttName="projectmenu"
        ttArgtype="project_keyno"
        [ttArgvalue]="get.project_keyno"
        ttShowHeadingButtons
    ></tt-webpagemenu-dashboard>
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'CUSTACTS'" [(ttOptions)]="activityGrid" *ngIf="!!activityGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'EMAILS'" [(ttOptions)]="emailGrid" *ngIf="!!emailGrid"></tt-grid>
    <tt-documents-grid
        [hidden]="get.gb_projectmenu_main !== 'DOCUMENTS'"
        style="display: block; flex: 1"
        rememberId="w_projectmenu.documents_grid"
        [params]="{
            argtype: 'project_keyno',
            argvalue: this.get.project_keyno,
            searchtext: '',
            doctype: 'd',
            onlyFilenames: '0',
        }"
    ></tt-documents-grid>
    <!-- <tt-grid [hidden]="get.gb_projectmenu_main !== 'DOCUMENTS'" [(ttOptions)]="documentsGrid" *ngIf="!!documentsGrid"></tt-grid> -->
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'ORDERHEADS'" [(ttOptions)]="ordersGrid" *ngIf="!!ordersGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'PURCHHEADS'" [(ttOptions)]="purchasesGrid" *ngIf="!!purchasesGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'INCOMING_INVOICE'" [(ttOptions)]="incomingInvoicesGrid" *ngIf="!!incomingInvoicesGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'POWTIMES'" [(ttOptions)]="powtimesGrid" *ngIf="!!powtimesGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_projectmenu_main !== 'DOCPACKS'" [(ttOptions)]="dockpacksGrid" *ngIf="!!dockpacksGrid"></tt-grid>
    <tt-project-folders [hidden]="get.gb_projectmenu_main !== 'FOLDERS'" class="flex-1" *ngIf="!!params" [params]="params"></tt-project-folders>
    <div [hidden]="get.gb_projectmenu_main !== 'FUNCTIONS'">
        <tt-card [hidden]="get.gb_projectmenu_main !== 'FUNCTIONS'" ttHeading="h_functions" class="col-md-4 sp-5 col-xs-12">
            <tt-button-goto ttText="projectmenu_edit_project" ttGoto="project" [ttGotoParms]="{ project_keyno: get.project_keyno }"></tt-button-goto>
            <tt-button-goto
                ttText="projectmenu_prosess"
                [ttBadge]="'' + get.nbr_of_projectprosess"
                ttGoto="projectprocesses"
                [ttGotoParms]="{ project_keyno: get.project_keyno }"
                tt-text-align="left"
            ></tt-button-goto>
            <tt-button-goto
                ttText="projectmenu_activities"
                [ttBadge]="get.activities_badge"
                ttGoto="custactsearch"
                [ttGotoParms]="{ filterfield: 'project_keyno', filtervalue: get.project_keyno, custacttype: 'A' }"
            ></tt-button-goto>
            <tt-button-goto ttText="projectmenu_orders" [ttBadge]="get.orders_badge" ttGoto="orderheads" [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"></tt-button-goto>
            <tt-button-goto
                ttText="projectmenu_purchases"
                [ttBadge]="get.purchases_badge"
                ttGoto="purchheads"
                [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"
            ></tt-button-goto>
            <tt-button-goto
                *ngIf="get.show_button_documents === '1'"
                ttText="projectmenu_documents"
                [ttBadge]="get.nbr_of_documents"
                ttGoto="documents"
                [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"
            ></tt-button-goto>
            <tt-button-goto
                *ngIf="get.show_button_pictures === '1'"
                ttText="projectmenu_pictures"
                [ttBadge]="get.nbr_of_pictures"
                ttGoto="pictures"
                [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"
            ></tt-button-goto>
            <tt-button-goto
                *ngIf="get.show_button_timesheetdiary === '1'"
                ttText="projectmenu_timesheetdiary"
                [ttBadge]="get.sum_hours_total"
                ttGoto="timesheetdiary"
                [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"
            ></tt-button-goto>
            <tt-button-goto
                *ngIf="get.show_button_gantt === '1'"
                ttText="projectmenu_gantt"
                ttGoto="custactgantt"
                [ttGotoParms]="{ connectto: 'project_keyno', connectto_value: get.project_keyno }"
            ></tt-button-goto>
            <tt-button-goto ttText="projectmenu_projectactivitytype" ttGoto="projectactivitytypes" [ttGotoParms]="{ project_keyno: get.project_keyno }"></tt-button-goto>
            <tt-button-goto ttText="projectmenu_prepayments" ttGoto="prepayments" [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"></tt-button-goto>
            <tt-button-goto
                *ngIf="get.show_paymentplans === '1'"
                ttText="projectmenu_paymentplans"
                ttGoto="paymentplans"
                [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"
            ></tt-button-goto>
            <tt-button-goto
                *ngIf="get.show_button_custactplanning === '1'"
                ttText="projectmenu_custactplanning"
                ttGoto="custactplanning"
                [ttGotoParms]="{ argtype: 'project_keyno', argvalue: get.project_keyno }"
            ></tt-button-goto>
        </tt-card>
        <tt-card ttHeading="h_summary" class="col-md-4 sp-5 col-xs-12">
            <tt-field-group>
                <tt-input class="col-3" ttLabel="project_keyno" [ttModel]="get.project_keyno" ttReadonly></tt-input>
                <tt-input class="col-9" ttLabel="project_name" [ttModel]="get.project_name" ttReadonly></tt-input>
            </tt-field-group>
            <tt-textarea ttLabel="description" [ttModel]="get.description" ttReadonly></tt-textarea>
            <tt-field-group>
                <tt-input-number ttLabel="sum_ordervalue_locval" [ttModel]="get.sum_ordervalue_locval" ttDecimals="2" ttReadonly></tt-input-number>
                <tt-input-number ttLabel="sum_purchasevalue_locval" [ttModel]="get.sum_purchasevalue_locval" ttDecimals="2" ttReadonly></tt-input-number>
                <tt-input-number ttLabel="sum_hours_total" [ttModel]="get.sum_hours_total" ttDecimals="2" ttReadonly></tt-input-number>
            </tt-field-group>
        </tt-card>
    </div>
</ng-container>
